import { render, staticRenderFns } from "./pay_by_bank_settings.vue?vue&type=template&id=8b671834&"
import script from "./pay_by_bank_settings.vue?vue&type=script&lang=js&"
export * from "./pay_by_bank_settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports